export default {
    events: [],
    consultations: []
}